import { useColorScheme } from '../../lib/hooks';
import { useTranslation } from '../../i18n/hooks/useTranslation';

/**
 * Color-scheme- and language-aware logo.
 * Reads dark mode from Mantine's data-mantine-color-scheme attribute and the
 * active language to pick the English vs Bangla logo art.
 */
export default function Logo({ w = 120, alt = 'SohozKaj', ...rest }) {
    const scheme = useColorScheme();
    const { currentLanguage } = useTranslation();
    const isDark = scheme === 'dark';
    const isEn = currentLanguage === 'en';
    const src = isEn
        ? (isDark ? '/images/logo-white-en.svg' : '/images/logo-en.svg')
        : (isDark ? '/images/logo-white.svg' : '/images/logo.svg');

    return (
        <span className="inline-block" style={{ width: w }}>
            <img
                src={src}
                alt={alt}
                width={w}
                height="auto"
                className="block h-auto"
                style={{ width: w }}
                {...rest}
            />
        </span>
    );
}
